import type { GameDetails } from '../shared/interfaces';
import { GameType } from '../shared/enume';

type WinnerGameDetails = Pick<GameDetails, 'teamA' | 'teamB' | 'teamC' | 'gameType'>;

/** Map API `winningTeam` / stored winner to the label shown in match result UI. */
export function resolveMatchWinnerDisplayName(
  winningTeam: unknown,
  gameDetails: WinnerGameDetails,
): string {
  if (winningTeam === undefined || winningTeam === null || String(winningTeam).trim() === '') {
    return 'Unknown';
  }

  const wt = String(winningTeam).trim();
  const upper = wt.toUpperCase();
  if (upper === 'TIE') return 'Tie';
  if (upper === 'ABANDONED' || upper === 'ABANDONE') return 'Abandoned';

  const isTest = gameDetails.gameType?.toLowerCase() === GameType.test;

  const teamA = gameDetails.teamA ?? '';
  const teamB = gameDetails.teamB ?? '';
  const teamC = gameDetails.teamC ?? '';

  if (upper === 'D' || upper === 'DRAW') {
    return 'DRAW';
  }

  if (upper === 'A' || upper === teamA.toUpperCase() || wt === teamA.charAt(0).toUpperCase()) {
    return teamA;
  }

  if (upper === 'B' || upper === teamB.toUpperCase() || wt === teamB.charAt(0).toUpperCase()) {
    return teamB;
  }

  if (isTest) {
    if (
      upper === teamC.toUpperCase() ||
      teamC.toLowerCase() === 'draw' ||
      upper === 'C' ||
      wt === teamC.charAt(0).toUpperCase()
    ) {
      return 'DRAW';
    }
  } else if (
    teamC &&
    (upper === teamC.toUpperCase() || upper === 'C' || wt === teamC.charAt(0).toUpperCase())
  ) {
    return teamC;
  }

  if (/^\d+(\.\d+)?$/.test(wt) && Number(wt) > 0) {
    return `${wt} Runs`;
  }

  return 'Unknown';
}

/** `firstChar` sent to match-over API when Draw wins a test match. */
export function resolveMatchOverFirstChar(
  winnerTeam: string,
  gameDetails: WinnerGameDetails,
  result?: 'teamA' | 'teamB' | 'teamC' | 'draw' | 'tie' | 'abandoned',
): string | null {
  const upper = winnerTeam.trim().toUpperCase();
  const isTest = gameDetails.gameType?.toLowerCase() === GameType.test;

  if (
    isTest &&
    (result === 'draw' ||
      result === 'teamC' ||
      upper === 'DRAW' ||
      upper === (gameDetails.teamC ?? '').toUpperCase())
  ) {
    return 'D';
  }

  return null;
}
